import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import {Oauth} from '../models/oauth/oauth.model';
import {App} from 'ionic-angular';
import {ModelService} from './model.service';
import {HttpHeaders} from '@angular/common/http';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class OauthService extends ModelService {
  private oauthData: Oauth;

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(tools);
  }

  protected handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  userIsLoggedIn() {
    this.oauthData = this.tools.localStorageService.getOauthToken();

    if (this.oauthData) {
      // this.expire(this.lsService, this.http, this.app);
      // this.expire(420);
    }

    return !!this.oauthData;
  }

  getHeaders(param = null) {
    if (this.userIsLoggedIn()) {
      const beneficiaire = this.tools.localStorageService.getBeneficiaire();
      const ce = this.tools.localStorageService.getCe();
      const version = this.appProvider.version;

      const headers: any = {
        'Authorization': `Bearer ${this.tools.localStorageService.getOauthToken().access_token}`
      };

      if (param && typeof (param) === 'object' && 'beneficiaireMatricule' in param) {
        headers.beneficiaire = param.beneficiaireMatricule;
      } else if (beneficiaire) {
        headers.beneficiaire = beneficiaire.codeMatricule;
      }

      if (ce && ce !== Object(ce)) { // Delete old version of CE cache
        this.logOut(this.app);
        this.tools.toast.create('Vous avez été déconnecté');
      }
      if (ce && ce === Object(ce) && ce && 'code' in ce) { // New object to CE cache
        headers.ce = ce.code;
      }

      if (!version) {
        this.logOut(this.app);
        this.tools.toast.create('Vous avez été déconnecté');
      }
      else  { // New object to CE cache
        headers.version = version;
      }

      if (param && param === 'formData') {
        return Object.assign(headers, {
          'Content-Type': 'application/x-www-form-urlencoded',
        });
      } else if (param && param === 'upload') {
        return headers;
      } else {
        return Object.assign(headers, {
          'Content-Type': 'application/json',
        });
      }
    } else {
      return {
        'Content-Type': 'application/json'
      };
    }
  }

  updateHttpHeaders(param = null): HttpHeaders {
    const headers = this.getHeaders(param);
    return new HttpHeaders(headers);
  }

  updateHeaders(param = null): Headers {
    const headers = this.getHeaders(param);
    return new Headers(headers);
  }

  getOauthMessage() {
    const oauthMessage = this.tools.localStorageService.getOauthToken().message;
    return oauthMessage;
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/oauth.service.ts